var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/maximize-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/maximize-3_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maximize-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.54167 17.4166H12.2917C16.25 17.4166 17.8333 15.8333 17.8333 11.875V7.12498C17.8333 3.16665 16.25 1.58331 12.2917 1.58331H7.54167C3.58333 1.58331 2 3.16665 2 7.12498V11.875C2 15.8333 3.58333 17.4166 7.54167 17.4166Z",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 6.81535C12.1524 4.39497 7.84762 4.39497 5 6.81535L7.07619 10.0001C8.74286 8.58059 11.2571 8.58059 12.9238 10.0001L15 6.81535Z",
    stroke: "#101513",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weight-icon.781ff16c409c229b7216627b1e81070d.svg";
export { ForwardRef as ReactComponent };